/*
 * #563 (WCAG 4.1.3): announce product page status changes through the shared polite live region.
 * Hooks in from outside product-form.js / subscriptions-widget.js: it watches the button price label and
 * subscribes to the existing cartUpdate pub/sub event. English only, like the rest of the PDP copy.
 */
(function () {
  const say = (msg) => {
    if (window.StashLiveRegion) window.StashLiveRegion.announce(msg);
  };

  function watchPrice() {
    const label = document.querySelector('#mainBtnBuy button span#money');
    if (!label) return;
    let last = label.textContent.trim();
    let timer = null;
    new MutationObserver(() => {
      const now = label.textContent.trim();
      if (now === last) return;
      last = now;
      // Pack, quantity and purchase-option changes can rewrite the label several times in one tick.
      clearTimeout(timer);
      timer = setTimeout(() => say('Price updated to ' + last), 400);
    }).observe(label, { childList: true, characterData: true, subtree: true });
  }

  function watchAddToCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Adds made inside the cart drawer announce their own, richer message (cart-drawer.js).
      if (event && event.source === 'product-form' && !event.fromDrawer) say('Added to cart');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    watchPrice();
    watchAddToCart();
  });
})();
